<template>
    <card-list>
        <subheader-list-item icon="fa-cube" title="Component Information"/>

        <container-list-item padded no-border>
            <b-field label="Title" label-position="inside">
                <b-input v-model="component.title"></b-input>
            </b-field>
        </container-list-item>

        <subheader-list-item icon="fa-cog" title="Settings"/>

        <container-list-item padded no-border>
            <b-field label="Type" label-position="inside">
                <b-select expanded v-model="component.type">
                    <option value="LESSON">Information/Content</option>
                    <option value="QUIZ">Assessment/Quiz</option>
                    <option value="CHECKPOINT">Checkpoint</option>
                    <option value="MEDIA">Video/Image</option>
                    <option value="FORM">Form</option>
                    <option value="SURVEY">Survey</option>
                    <option value="IFRAME">I-Frame</option>
                </b-select>
            </b-field>

            <b-field label="Description (Internal)" label-position="inside">
                <b-input type="textarea" v-model="component.description"></b-input>
            </b-field>

        </container-list-item>
    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import {client as http} from "../../http_client";
    import async from "async";

    export default {
        name: 'ApplicationComponentForm',
        props: {
            component: {
                type: Object,
                required: true
            }
        },
        components: {CardListItem, ContainerListItem, SubheaderListItem, CardList},
        data: function() {
            return {
                tags: [],
                filteredTags: []
            };
        },
        methods: {
            getFilteredTags(text) {
                this.filteredTags = this.tags.filter((option) => {
                    return option.tag
                        .toString()
                        .toLowerCase()
                        .indexOf(text.toLowerCase()) >= 0;
                });
            },
            // createTag(tag) {
            //     if (typeof tag === 'object') {
            //         return {tag: tag.tag, id: tag.id};
            //     } else {
            //         let newTag = {tag, id: null};
            //
            //         async.each(this.tags, (t, eCB) => {
            //             if (t.tag && tag.toLowerCase() === t.tag.toLowerCase()) {
            //                 eCB('found');
            //                 newTag.tag = t.tag;
            //                 newTag.id = t.id;
            //             } else {
            //                 eCB();
            //             }
            //         }, err => {
            //             if (err !== 'found') {
            //                 http.post('component-tags/', {tag}, {force: true}).then(response => {
            //                     this.tags.push(response.data);
            //                     newTag.id = response.data.id;
            //                 }).catch(err => {
            //                 });
            //             }
            //         });
            //         return newTag;
            //     }
            // }
        },
        computed: {
            // plainTags: function() {
            //     return this.tags.map(t => t.tag.toLowerCase());
            // }
        },
        mounted: function() {
            http.get('component-tags/', this.component, {force: true}).then(response => {
                // this.tags = response.data.map(t => t.tag);
                this.tags = response.data;
            }).catch(err => {
                this.tags = [];
            });
        }
    };

</script>
